/* eslint-disable no-unused-vars */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, colors } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#FFFFF',
    // backgroundColor: colors.lime[50],
  },
}));

const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="inherit"
      position="fixed"
    >
      <Toolbar>
        {/* <Typography variant="h3" className={classes.title}>
          CUSTOMER INFORMATION UPDATE FORM
        </Typography> */}
        <RouterLink to="/">
        <img alt="Logo" src="/images/logos/logo.jpeg" height={60} />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
